import cx from 'classnames';
import { CSSProperties, FC, PropsWithChildren } from 'react';

const ADHESION_PLACEMENT_STYLE: CSSProperties = {
  position: 'fixed',
  right: 0,
  bottom: 0,
  left: 0,
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'flex-end',
  zIndex: 2147483640,
  pointerEvents: 'none'
};

const ADHESION_PLACEMENT_SLOT_STYLE: CSSProperties = {
  width: '100%',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'flex-end',
  overflow: 'hidden',
  pointerEvents: 'auto'
};

type TAdhesionPlacementProps = PropsWithChildren<{
  className?: string;
  height?: CSSProperties['height'];
  maxWidth?: CSSProperties['maxWidth'];
  slotClassName?: string;
}>;

export const AdhesionPlacement: FC<TAdhesionPlacementProps> = ({
  children,
  className,
  height,
  maxWidth = 970,
  slotClassName
}) => (
  <div className={cx('rio-adhesion-placement', className)} style={ADHESION_PLACEMENT_STYLE}>
    <div
      className={cx('rio-adhesion-placement__slot', slotClassName)}
      style={{ ...ADHESION_PLACEMENT_SLOT_STYLE, height, maxWidth }}
    >
      {children}
    </div>
  </div>
);
